module.exports = __webpack_public_path__ + "img/b07d1db.png";